/**
 * Interior / pet / wedding register chip labels — tuples [ko, en, vi, ru].
 */

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, v]) => {
    if (Array.isArray(v) && v.length >= 4) out[k] = v[langIndex];
    else if (v && typeof v === 'object' && !Array.isArray(v)) out[k] = pick(v, langIndex);
    else out[k] = v;
  });
  return out;
}

const interior = {
  workApartment: ['아파트', 'Apartment', 'Căn hộ', 'Квартира'],
  workVilla: ['빌라/주택', 'Villa / house', 'Biệt thự / nhà', 'Вилла / дом'],
  workCommercial: ['상업공간', 'Commercial', 'Không gian thương mại', 'Коммерция'],
  workOffice: ['사무실', 'Office', 'Văn phòng', 'Офис'],
  workCafe: ['카페/식당', 'Cafe / restaurant', 'Quán / nhà hàng', 'Кафе / ресторан'],
  workNew: ['신축', 'New build', 'Xây mới', 'Новостройка'],
  specKitchen: ['주방 인테리어', 'Kitchen', 'Bếp', 'Кухня'],
  specBath: ['욕실 시공', 'Bathroom', 'Phòng tắm', 'Ванная'],
  specRemodel: ['전체 리모델링', 'Full remodel', 'Cải tạo toàn bộ', 'Полный ремонт'],
  specFloor: ['바닥/타일', 'Floor / tile', 'Sàn / gạch', 'Пол / плитка'],
  specPaint: ['도배/페인트', 'Wallpaper / paint', 'Giấy dán / sơn', 'Обои / краска'],
  specLight: ['조명/전기', 'Lighting / electric', 'Đèn / điện', 'Свет / электрика'],
  specDoor: ['창호/도어', 'Windows / doors', 'Cửa sổ / cửa', 'Окна / двери'],
  specStorage: ['수납/붙박이장', 'Built-in storage', 'Tủ âm tường', 'Встроенные шкафы'],
  spec3d: ['3D 설계', '3D design', 'Thiết kế 3D', '3D-проект'],
  specEco: ['친환경 자재', 'Eco materials', 'Vật liệu xanh', 'Экоматериалы'],
  specSmart: ['스마트홈', 'Smart home', 'Nhà thông minh', 'Умный дом'],
  specCommercial: ['상업공간 특화', 'Commercial specialist', 'Chuyên không gian TM', 'Коммерческие объекты'],
  areaSmall: ['10~30평', '10–30 pyeong', '10–30 pyong', '10–30 пхён'],
  areaMedium: ['30~60평', '30–60 pyeong', '30–60 pyong', '30–60 пхён'],
  areaLarge: ['60~100평', '60–100 pyeong', '60–100 pyong', '60–100 пхён'],
  areaXlarge: ['100평+', '100+ pyeong', '100+ pyong', '100+ пхён'],
};

const pet = {
  typeGrooming: ['미용/그루밍', 'Grooming', 'Cắt tỉa', 'Груминг'],
  typeBoarding: ['호텔링/위탁', 'Boarding', 'Gửi thú', 'Передержка'],
  typeTraining: ['훈련/교육', 'Training', 'Huấn luyện', 'Дрессировка'],
  typeVet: ['동물병원/통역', 'Vet / interpreter', 'Thú y / phiên dịch', 'Вет / перевод'],
  typeWalking: ['산책/운동', 'Walking', 'Dắt đi dạo', 'Выгул'],
  typeTransport: ['운송/이동', 'Transport', 'Vận chuyển', 'Перевозка'],
  typeSitting: ['방문 돌봄', 'House sitting', 'Chăm tại nhà', 'Няня на дому'],
  typeOther: ['기타', 'Other', 'Khác', 'Другое'],
  petDog: ['강아지', 'Dog', 'Chó', 'Собака'],
  petCat: ['고양이', 'Cat', 'Mèo', 'Кошка'],
  petBird: ['조류', 'Bird', 'Chim', 'Птица'],
  petFish: ['어류', 'Fish', 'Cá', 'Рыба'],
  petOther: ['기타', 'Other pets', 'Thú khác', 'Другие'],
  dur30: ['30분', '30 min', '30 phút', '30 мин'],
  dur60: ['1시간', '1 hour', '1 giờ', '1 час'],
  dur90: ['1시간 30분', '1.5 hours', '1,5 giờ', '1,5 часа'],
  dur120: ['2시간', '2 hours', '2 giờ', '2 часа'],
  dur180: ['3시간', '3 hours', '3 giờ', '3 часа'],
  durDay: ['1일', '1 day', '1 ngày', '1 день'],
  durNeg: ['협의', 'Negotiable', 'Thương lượng', 'По договорённости'],
  kakaoPh: ['카카오 오픈채팅 ID', 'Kakao open chat ID', 'ID chat mở Kakao', 'ID открытого чата Kakao'],
  zaloPh: ['Zalo 번호', 'Zalo number', 'Số Zalo', 'Номер Zalo'],
};

const wedding = {
  typeHall: ['웨딩홀', 'Wedding hall', 'Sảnh cưới', 'Банкетный зал'],
  typePhoto: ['스냅/촬영', 'Photo / film', 'Chụp / quay', 'Съёмка'],
  typeDress: ['드레스/수트', 'Dress / suit', 'Váy / vest', 'Платье / костюм'],
  typeMakeup: ['메이크업', 'Makeup', 'Trang điểm', 'Макияж'],
  typeCatering: ['케이터링', 'Catering', 'Tiệc', 'Кейтеринг'],
  typeFlower: ['플라워/부케', 'Flowers / bouquet', 'Hoa / bó hoa', 'Цветы / букет'],
  typeMc: ['MC/사회자', 'MC / host', 'MC / người dẫn', 'Ведущий'],
  typePackage: ['올인원 패키지', 'All-in package', 'Gói all-in', 'Пакет all-in'],
  incPlanner: ['웨딩 플래너', 'Wedding planner', 'Planner cưới', 'Планировщик'],
  incDress: ['드레스 대여', 'Dress rental', 'Thuê váy', 'Аренда платья'],
  incMakeup: ['메이크업', 'Makeup', 'Trang điểm', 'Макияж'],
  incBouquet: ['부케', 'Bouquet', 'Bó hoa', 'Букет'],
  incSnap: ['스냅 촬영', 'Photo session', 'Chụp ảnh', 'Фотосессия'],
  incVideo: ['영상 촬영', 'Videography', 'Quay phim', 'Видео'],
  incCatering: ['케이터링', 'Catering', 'Tiệc', 'Кейтеринг'],
  incDecor: ['꽃장식', 'Floral decor', 'Trang trí hoa', 'Цветочный декор'],
  incFitting: ['피팅', 'Fitting', 'Thử đồ', 'Примерка'],
  incRaw: ['원본 파일', 'Raw files', 'File gốc', 'Исходники'],
  incRetouch: ['리터칭', 'Retouching', 'Chỉnh ảnh', 'Ретушь'],
  incAlter: ['수선', 'Alterations', 'Sửa đồ', 'Подгонка'],
  incPickup: ['픽업/드랍', 'Pickup / drop', 'Đón / trả', 'Трансфер'],
  incInterp: ['통역', 'Interpreter', 'Phiên dịch', 'Переводчик'],
  maxPeople: ['최대 {n}명', 'Max {n} guests', 'Tối đa {n} khách', 'До {n} гостей'],
  kakaoPh: ['카카오 오픈채팅 ID', 'Kakao open chat ID', 'ID chat mở Kakao', 'ID открытого чата Kakao'],
  zaloPh: ['Zalo 번호', 'Zalo number', 'Số Zalo', 'Номер Zalo'],
};

function buildLang(i) {
  return {
    interior: pick(interior, i),
    pet: pick(pet, i),
    wedding: pick(wedding, i),
  };
}

export const phaseLocalRegisterChipsKo = buildLang(0);
export const phaseLocalRegisterChipsEn = buildLang(1);
export const phaseLocalRegisterChipsVi = buildLang(2);
export const phaseLocalRegisterChipsRu = buildLang(3);
